import { FC } from "react"
import classNames from "classnames"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import { ColorVariant } from "@/types/index"
import "./index.scss"

interface TagProps {
   label: string
   variant: ColorVariant
   iconName?: IconProps["name"]
   iconColor?: IconColor
   outlined?: boolean
}

const Tag: FC<TagProps> = ({
   label,
   variant,
   iconName,
   iconColor,
   outlined = false,
}) => {
   return (
      <span
         className={classNames("tag", `tag${variant}`, {
            "tag--outlined": outlined,
         })}
      >
         {iconName && (
            <Icon
               name={iconName}
               size="10"
               color={iconColor}
            />
         )}
         {label}
      </span>
   )
}

export default Tag
